import React from 'react'
import { MenuItem } from '@material-ui/core'
import classNames from 'classnames'
import makeStyles from '@material-ui/core/styles/makeStyles'
import styles from '../../../../../styles'
import SelectField from '../../../../../components/fields/SelectField'
import selectColorEnum from '../../../../../enums/selectEnums/SelectColorEnum'
import selectSizeEnum from '../../../../../enums/selectEnums/SelectSizeEnum'
import { TypeModel } from '../docs_model'
import { FormattedMessage, IntlShape, useIntl } from 'react-intl'
import langEnum from '../../../../../enums/langEnum'

interface AcceptingProps {
	listYear: Array<number>,
	listType: Array<TypeModel>,
	year: number,
	type: string,
	setYear: React.Dispatch<React.SetStateAction<number>>
	setType: React.Dispatch<React.SetStateAction<string>>,
	selectAll: string,
	isLargeScreen: boolean
}

type SelectFilterProps = AcceptingProps

const useStyle = makeStyles((theme) => ({
		...styles(theme),
		textSelect: {
			color: theme.palette.blue['50']
		},
		selectContainer: {
			padding: '0px 5%',
			paddingTop: '4%',
			'& :first-child': {
				marginRight: '2%'
			}
		}
	}
))

const SelectFilter: React.FC<SelectFilterProps> = (
	{
		listType,
		listYear,
		setYear,
		setType,
		year,
		type,
		selectAll,
		isLargeScreen
	}
) => {
	const classes = useStyle()
	const intl: IntlShape = useIntl()

	const textSelect = classNames(
		classes.semiBold,
		isLargeScreen ? classes.text8 : classes.text14,
		classes.textSelect
	)

	const inputText = classNames(
		isLargeScreen ? classes.text8 : classes.text14,
		classes.semiBold,
		classes.colorBlue
	)

	//Set state year to selected year value
	const handleChangeYear = (event: React.ChangeEvent<{ value: unknown }>) => {
		setYear(event.target.value as number)
	}

	//Set state type to selected type value
	const handleChangeType = (event: React.ChangeEvent<{ value: unknown }>) => {
		setType(event.target.value as string)
	}

	return (
		<div className={classes.selectContainer}>
			<SelectField
				inputTextStyle={inputText}
				value={type}
				onChange={handleChangeType}
				backgroundColor={selectColorEnum.grey}
				size={isLargeScreen ? selectSizeEnum.big : selectSizeEnum.small}
			>
				<MenuItem
					value={selectAll}
					className={textSelect}
				>
					{selectAll}
				</MenuItem>
				{
					listType.map((t: TypeModel) =>
						<MenuItem
							key={t.type_document}
							value={t.type_document}
							className={textSelect}
						>
							{(intl.locale === langEnum.fr) ? t.renommage_fr : t.renommage_en}
						</MenuItem>
					)
				}
			</SelectField>
			<SelectField
				value={year}
				inputTextStyle={inputText}
				onChange={handleChangeYear}
				backgroundColor={selectColorEnum.grey}
				size={isLargeScreen ? selectSizeEnum.big : selectSizeEnum.small}
			>
				{
					listYear.map((year: number) =>
						<MenuItem
							key={year}
							value={year}
							className={textSelect}
						>
							{
								year === Math.min(...listYear) ?
									`${year} ${intl.formatMessage({ id: 'contracts.document.andBefore', defaultMessage: 'et avant', description: 'and before text' })}`
									:
									year === Math.max(...listYear) ?
										<FormattedMessage
											id="contracts.document.selectAll"
											defaultMessage="Tous"
											description="type All text"
										/>
										:
										year
							}
						</MenuItem>
					)
				}

			</SelectField>
		</div>
	)
}

export default SelectFilter
